import { formatCalendarDate } from "@ui/lib/date"
import metadata from "virtual:news-metadata"

export const pressReleases = metadata.map((release) => ({
  ...release,
  dateFormatted: formatCalendarDate(release.date, "longDateGB"),
}))
